<template>
  <div id="modal-base" class="modal fade preset-manager" tabindex="-1" role="dialog" hidden
       @click.self="previewIsHidden=true">
    <div ref="modaldialogbase" class="modal-dialog" role="document"
         style="height:  85%; width:90%; max-height: 90%; padding: 0">
      <div class="modal-content" v-show="previewIsHidden">
        <div class="modal-header" style="font-size: 14px">
          <div class="row">
            <div class="col-lg-12">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" style="margin: 10px">
                <img src="/images/icons_presetmanager/close.svg" style="height: 3vh">
              </button>
            </div>
          </div>
          <br>
          <div class="row">
            <div class="col-lg-3 col-xs-12 filter-button-wrapper" style="height:100%; z-index: 1;"
                 v-click-outside="closeFilter">
              <button class="btn filter-button" ref="tagpopupbutton"
                      @click="placeTagPopup">FILTER <img src="/images/icons_presetmanager/chevron_unten.svg">
              </button>
              <div class="row d-md-block tagdropdown" :class="{hidden: isFilterHidden}"
                   ref="tagpopup"
                   :style="{top: `${filterTop}px`, left: `${filterLeft}px`}">
                <div class="col-md-6 border">
                  <div class="filter">
                    <label style="font-size: 16px">Typ</label><br>
                    <div class="m-25vh">
                      <div tabindex="-1" class="tagify__tag" :value="{value}"
                           @click="addTags(value)"
                           v-for="value in ['Gutschein','Einladung','Bonusscheck']"
                           :class="[array.includes(value) ? 'fillBg' : '']">
                        <div>
                          <span class="tagify__tag-text">{{ value }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="filter">
                    <label style="font-size: 16px">Zeitraum</label><br>
                    <div class="m-25vh">
                      <div tabindex="-1" class="tagify__tag" :value="{value}"
                           @click="addTags(value.name)"
                           v-for="value in periodTags"
                           :class="[array.includes(value.name) ? 'fillBg' : '']">
                        <div>
                          <span class="tagify__tag-text">{{ value.name }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 border filter">
                  <label style="font-size: 16px">Kategorien</label><br>
                  <div class="m-25vh">
                    <div title="test" tabindex="-1" class="tagify__tag " :value="{value}"
                         @click="addTags(value.name)"
                         v-for="value in categoryTags"
                         :class="[array.includes(value.name) ? 'fillBg' : '']">
                      <div>
                        <span class="tagify__tag-text">{{ value.name }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-9 col-xs-12">
              <div class="col-lg-12 col-xs-12 "
                   style="background: white; height:7vh; box-shadow: 0 0 4px 1px #BBBBBB; border-radius: 3px">
                <div class="col-lg-1 col-xs-12 magnifier-wrapper">
                  <img src="/images/icons_presetmanager/lupe.svg" class="magnifier">
                </div>
                <div class="col-lg-8 col-xs-12 t-height tags-textarea">
                  <textarea class="custom" ref="tagsinput" v-model="tags"></textarea>
                </div>
                <div class="col-lg-3 col-xs-12 remove-filters">
                  <button class="btn remove-filters-button"
                          @click="removeTags">
                    <img src="/images/icons_presetmanager/muelltonne.svg"> Filter leeren
                  </button>
                </div>
              </div>
            </div>
          </div>
          <br>
          <div class="row">
            <div class="col-lg-6 col-xs-12 padding-left">
              <p style="line-height: 3vh; font-size: 18px">
                <b>{{ presetsCounted }}</b> Vorlagen gefunden
              </p>
            </div>
            <div class="col-lg-6">
              <div class="pull-right select-wrapper">
                <label for="presets-order" style="font-weight: normal" class="font-18">Sortierung: </label>
                <select ref="presetsorder" id="presets-order" @change="setMode()">
                  <option value="relevance">Relevanz</option>
                  <option value="date-desc">Datum absteigend</option>
                  <option value="date-asc">Datum aufsteigend</option>
                </select>
              </div>
              <div class="pull-right" style="padding-right: 3vh">
                <label style="vertical-align: middle;font-weight: normal" class="font-18">Nur Gratisinhalte: </label>
                <toggle-button @change="onToggleChange($event)" color="#1A7BB9"></toggle-button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-body" style="max-height: 80vh; overflow: auto">
          <div class="row" v-for="presetChunked in presetsChunked" style="overflow: visible">
            <div class="col-lg-3 card-wrapper" v-for="preset in presetChunked">
              <div v-if="presetPackages.includes(preset['v3_preset_package_id']) || !freeOnly" class="card-card">
                <div v-if="!presetPackages.includes(preset['v3_preset_package_id'])">
                  <img src="/images/icons_presetmanager/schloss.svg"
                       style="position: absolute; right: 25px; top: 10px; height: 2vh"
                       :content="presetPackageNames[preset['v3_preset_package_id']] + ' freischalten'" v-tippy>
                </div>
                <div class="card-header-wrapper">
                  <p v-if="preset && preset.name_internal" style="font-size: 24px">
                    <b>{{ preset.name_internal | truncate(20,'...') }}</b>
                  </p>
                  <div v-if="!preset || !preset.name_internal">
                    &nbsp;
                  </div>
                  <p style="font-size: 18px">
                    Vorlagennummer: {{ preset.id }}
                  </p>
                </div>
                <img :src="campaignPreviewImages[preset.id]" style="width: 90%; border-radius: 3px;height: auto">
                <div style="position: absolute; bottom: 70px; width: 90%;">
                  <hr class="separator">
                  <a class="btn btn-success font-18" style="width: 45%;"
                     :href="getPresetUrl(preset.id)"
                     v-if="presetPackages.includes(preset['v3_preset_package_id'])">
                    Auswählen
                  </a>
                  <button class="btn btn-outline btn-success font-18" type="button" style="width: 45%"
                          @click="showpreview(preset)">
                    Vorschau
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-content" v-show="!previewIsHidden" v-if="previewPreset" style="min-width: 100%; min-height: 100%;">
        <div class="modal-header" style="font-size: 22px; padding: 20px 30px">
          <button type="button" class="close" style="float: right" @click="previewIsHidden=true">
            <img src="/images/icons_presetmanager/close-circle.svg" style="height: 5vh">
          </button>
          <div style="padding-left: 3vw">
            <div style="font-size: 26px; font-weight: bold; margin-bottom: 5px">
              {{ previewPreset.name_internal ? previewPreset.name_internal : ' ' }}
            </div>
            <div style="color: #AAACAD" class="font-18">
              Vorlagen-Nr. {{ previewPreset.id }}
            </div>
          </div>
        </div>
        <div class="modal-body" style="font-size: 18px; background: white;padding-bottom: 10px">
          <div class="row" style="margin: 0; top:10vh">
            <div class="col-md-3" style="padding-left: 3vw; text-align: left; ">
              <div>
                <b>Typ:</b>
                <p class="m-t">{{ $t("backend.v3_campaigns.types." + previewPreset.type) }}</p>
                <br>
                <b>Kategorien:</b>
                <p class="m-t" v-for="category in previewPreset.category_tags">{{ category }}</p>
                <br>
                <b>Paket:</b>
                <p class="m-t">{{ presetPackageNames[previewPreset.v3_preset_package_id] }}</p>
              </div>
              <br>
              <div class="font-15">
                <b>Eingestellt:</b>
                <p class="m-t">{{ previewPreset.created_at | date('DD/MM/YYYY') }}</p>
              </div>
            </div>
            <div class="col-md-9 scrolling-wrapper" style="padding: 2px">
              <!--              PUSHES PREVIEW-->
              <div class="iframe-preview" v-if="previewPreset.notifications && previewPreset.notifications.length > 0">
                <div v-if="!spinnerIsHidden[4]" :id="`spinner4`" style="top: 50%; left: 50%; position: absolute">
                  <i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i>
                </div>
                <iframe :id="`preview_iframe4`" style="width: 450px; height: 850px; border-radius:10px"
                        :src="!previewIsHidden ? `/backend/v3_campaign_presets/get/${previewPreset.id}/4` : ''"
                        @load="hideSpinner(4)">
                </iframe>
              </div>
              <!--              LIST & DETAIL PREVIEW-->
              <div class="iframe-preview" v-for="n in 2">
                <div v-if="!spinnerIsHidden[n]" :id="`spinner${n}`" style="top: 50%; left: 50%; position: absolute">
                  <i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i>
                </div>
                <iframe :id="`preview_iframe${n}`" style="width: 450px; height: 850px; border-radius:10px"
                        :src="!previewIsHidden ? `/backend/v3_campaign_presets/get/${previewPreset.id}/${n}` : ''"
                        @load="hideSpinner(n)">
                </iframe>
              </div>
              <!--              EVENTS PREVIEW-->
              <div class="iframe-preview"
                   v-if="(previewPreset.type === 'invitation' && previewPreset.events && previewPreset.events.length > 0) || previewPreset.type === 'coupon'">
                <div v-if="!spinnerIsHidden[3]" :id="`spinner3`" style="top: 50%; left: 50%; position: absolute">
                  <i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i>
                </div>
                <iframe :id="`preview_iframe3`" style="width: 450px; height: 850px; border-radius:10px"
                        :src="!previewIsHidden ? `/backend/v3_campaign_presets/get/${previewPreset.id}/3` : ''"
                        @load="hideSpinner(3)">
                </iframe>
              </div>
            </div>
          </div>
          <div class="row" style="margin: 0; top:10vh">
            <div class="col-md-3">
            </div>
            <div class="col-md-9" style="padding: 20px 0">
              <a :href="getPresetUrl(previewPreset.id)"
                 v-if="presetPackages.includes(previewPreset.v3_preset_package_id)" class="btn btn-success"
                 type="button" style="width: 100%; font-size: 20px;margin:0;padding:10px">Vorlage auswählen
              </a>
              <button v-if="!presetPackages.includes(previewPreset.v3_preset_package_id)" class="btn btn-success"
                      type="button" style="width: 100%; font-size: 20px;margin:0;padding:10px" disabled>Diese Vorlage
                ist im Paket
                {{ presetPackageNames[previewPreset.v3_preset_package_id] || '' }} enthalten!
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import truncate from "../common/filters/truncate";
import date from "../common/filters/date";

export default {
  name: "CampaignPresetManager",
  props: [
    'campaignPresetsByRelevance',
    'campaignPresetsByDateAsc',
    'campaignPresetsByDateDesc',
    'campaignPresetsImages',
    'campaignPreviewImages',
    'categoryTags',
    'periodTags',
    'presetPackages',
    'presetPackageNames',
    'campaignId',
    'campaignLoadType'
  ],
  components: {},
  filters: {
    truncate,
    date
  },
  events: {},
  data() {
    return {
      isFilterHidden: true,
      tags: '',
      filterTop: 0,
      filterLeft: 0,
      tagify: null,
      array: [],
      freeOnly: false,
      mode: 'relevance',
      previewPreset: this.campaignPresetsByRelevance[0],
      previewIsHidden: true,
      spinnerIsHidden: {1: false, 2: false, 3: false, 4: false},
      previewTags: [],
      typeTagTransform: {"coupon": "gutschein", "bonus_voucher": "bonusscheck", "invitation": "einladung"},
      typeArray: ["gutschein", "einladung", "bonusscheck"]
    }
  },
  mounted() {
    this.tagify = new tagify(this.$refs.tagsinput, {delimiters: " |,",});
    if (this.tagify.on !== undefined) {
      this.tagify.on('remove add edit:updated', this.updateTags);
    }
  },
  computed: {
    presetsChunked() {
      return _.chunk(this.filteredList, 4)
    },
    presetsCounted() {
      let presetCount = 0;
      this.presetsChunked.forEach(preset => {
        presetCount += preset.length
      })
      return presetCount;
    },
    filteredList() {
      let campaignPresets;
      switch (this.mode) {
        case "relevance":
          campaignPresets = this.$props.campaignPresetsByRelevance;
          break;
        case "date-asc":
          campaignPresets = this.$props.campaignPresetsByDateAsc;
          break;
        default:
          campaignPresets = this.$props.campaignPresetsByDateDesc;
          break;
      }
      if (this.array.length > 0) {
        let filtered = [];
        let typeTags = [];
        let otherTags = [];
        this.array.forEach((tag) => {
          let tagLowerCase = tag.toLowerCase();
          if (this.typeArray.includes(tagLowerCase)) {
            typeTags.push(tagLowerCase);
          } else {
            otherTags.push(tagLowerCase);
          }
        });
        campaignPresets.filter(preset => {
          for (let tag of this.array.values()) {
            let tagLowerCase = tag.toLowerCase();
            if (((!typeTags.includes(tagLowerCase) && preset.name_internal && preset.name_internal.toLowerCase().includes(tagLowerCase)) ||
                otherTags.length === 0 ||
                (preset.period_tags != null && preset.period_tags.map(v => v.toLowerCase()).includes(tagLowerCase)) ||
                (preset.category_tags != null && preset.category_tags.map(v => v.toLowerCase()).includes(tagLowerCase))) &&
                (typeTags.length === 0 || typeTags.map(v => v.toLowerCase()).includes(this.typeTagTransform[preset.type]))) {
              if (this.freeOnly && preset.v3_preset_package_id !== 1) {
                break;
              } else {
                filtered.push(preset);
                break;
              }
            }
          }
        })
        return filtered;
      } else {
        let filtered = [];
        campaignPresets.filter(preset => {
          if (this.freeOnly && preset.v3_preset_package_id !== 1) {
          } else {
            filtered.push(preset);
          }
        });
        return filtered;
      }
    }
  },
  methods: {
    showpreview(preset) {
      let tags = [];
      try {
        tags = JSON.parse(this.$refs.tagsinput.value);
      } catch (e) {
      }

      this.previewPreset = preset;
      this.previewIsHidden = false;
      this.spinnerIsHidden = {1: false, 2: false, 3: false};
    },
    onToggleChange(event) {
      this.freeOnly = event.value
    },
    placeTagPopup() {
      this.isFilterHidden = !this.isFilterHidden;
      let popupButtonBoundRect = this.$refs.tagpopupbutton.getBoundingClientRect();
      let modalBoundRect = this.$refs.modaldialogbase.getBoundingClientRect();
      this.filterTop = popupButtonBoundRect.bottom - modalBoundRect.top - 5;
      this.filterLeft = popupButtonBoundRect.left - modalBoundRect.left + 15;
    },
    addTags(tag) {
      if (!this.array.includes(tag)) {
        this.tagify.addTags(tag)
        this.updateTags()
      }
    },
    removeTags() {
      this.tagify.removeAllTags();
      this.updateTags();
    },
    hideSpinner(i) {
      this.spinnerIsHidden[i] = true;
    },
    setMode() {
      this.mode = document.getElementById('presets-order').value;
    },
    getPresetUrl(presetId) {
      return `/backend/v3_campaign_presets/store/${presetId}/${this.campaignLoadType}`;
    },
    updateTags() {
      let tags = []
      try {
        tags = JSON.parse(this.$refs.tagsinput.value);
      } catch (e) {
      }
      this.array = [];
      tags.forEach((tag) => {
        this.array.push(tag.value)
      })
    },
    closeFilter() {
      if (!this.isFilterHidden) {
        this.isFilterHidden = true;
      }
    }
  }
}
</script>

<style lang="scss">
.select-wrapper {
  font-size: 18px;
}

.modal-header {
  padding: 10px 40px 10px 40px;
}

.modal-content {
  background: #EBEBEB;
}

.filter-button {
  padding-left: 25px;
  background: white;
  width: 100%;
  font-weight: bold;
  text-align: left;
  position: relative;
  box-shadow: 0 0 4px 1px #BBBBBB;
  font-size: 18px;
  height: 7vh;
  margin-left: 0 !important;
}

.filter-button > img {
  height: 14px;
  position: absolute;
  right: 25px;
  margin-top: 4px;
}

.remove-filters {
  padding: 0;
  text-align: right;
  height: 7vh;
  margin-left: 2vh;
}

.remove-filters-button {
  background: none;
  float: none;
  width: 90%;
  height: 7vh;
  font-size: 15px;
  overflow: hidden;
  text-align: right;
  color: #AAACAD;
}

.remove-filters-button > img {
  height: 15px;
  margin-bottom: 5px;
}

.tagdropdown {
  position: fixed;
  background: white;
  z-index: 1000;
  padding: 10px;
  border-radius: 0 0 5px 5px;
  -moz-box-shadow: 0px 8px 10px #BBBBBB;
  -webkit-box-shadow: 0px 8px 10px #BBBBBB;
  box-shadow: 0px 8px 10px #BBBBBB;
}

@media only screen and (min-width: 600px) {

  .tagdropdown {
    max-width: 40vw;
  }

  .t-height {
    height: 8vh;
  }
}

@media only screen and (max-width: 600px) {
  .tagdropdown {
    max-width: 80vw;
  }

  .t-height {
    height: 8vh;
    margin-bottom: 4vh;
  }
}

.separator {
  margin: 5%;
}

label {
  margin: 5px 0 0 0;
}

#presets-order {
  background: none;
  border-color: transparent;
  margin: 0 0 0 10px;
}

#presets-order:focus {
  border-color: transparent;
  outline: none !important;
}

.filter-button-wrapper {
  padding-left: 0.6vh;
  padding-right: 0;
}

.filter-button-wrapper > .btn {
  margin-left: 0;
}

.btn:active {
  box-shadow: unset !important;
}

.magnifier {
  height: 3vh;
  margin-top: 2vh;
}

.tags-textarea {
  font-size: 16px;
  height: 6vh;
  border: none;
}

iframe {
  border-width: 0;
}

.custom {
  overflow: auto;
  border-radius: 5px;
  --tags-border-color: #FFF;
  min-height: 100%;
  font-size: 18px;
  width: 100%;
  float: left;
}

.tags-textarea > .tagify {
  width: 100%;
  overflow: auto;
  flex-wrap: unset;
  border: none !important;
}

.tags-textarea > .tagify > .tagify__tag-text {
  font-size: 16px;
}

.tags-textarea > tags {
  border: unset !important;
  height: 7vh;
}

.magnifier-wrapper {
  padding: 0 4vh 0 0;
  width: 2.33%;
}

.fillBg div, .fillBg > div > * {
  background: #e1eaf1;
  border-radius: 14px;
}

.fillBg > div {
  border: 1px solid #3595f6;
}

.fillBg > div:hover {
  border: unset;
}

.m-25vh {
  margin: 1vh 0;
}

.card-header-wrapper {
  margin-top: 20px;
  padding: 0 5px;
}

.scrolling-wrapper {
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
  height: 865px;

  .iframe-preview {
    display: inline-block;
  }

  &::-webkit-scrollbar-thumb {
    background: #AAACAD;
  }
}

.m-t {
  margin-top: 0.5vh;
}

.font-18 {
  font-size: 18px !important;
}

.font-15 {
  font-size: 15px !important;
}

@media only screen and (max-width: 1919px) {

  .card-wrapper {
    height: 370px;

    .card-card {
      margin: auto;
      background: white;
      box-shadow: 0 0 4px 1px #BBBBBB;
      height: 320px;
      width: auto;
      border-radius: 3px;
      overflow: hidden;
      word-break: break-word
    }
  }
}

@media only screen and (min-width: 1920px) and (max-width: 2559px) {

  .card-wrapper {
    height: 390px;

    .card-card {
      margin: auto;
      background: white;
      box-shadow: 0 0 4px 1px #BBBBBB;
      height: 335px;
      width: auto;
      border-radius: 3px;
      overflow: hidden;
      word-break: break-word
    }
  }
}

@media only screen and (min-width: 2560px) {

  .card-wrapper {
    height: 450px;

    .card-card {
      margin: auto;
      background: white;
      box-shadow: 0 0 4px 1px #BBBBBB;
      height: 400px;
      width: auto;
      border-radius: 3px;
      overflow: hidden;
      word-break: break-word
    }
  }
}
</style>
